export default "__VITE_ASSET__4c90fa3e__"